import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from 'history';

import createStores from './stores';
import './index.scss';
import App from './App';

const history = createBrowserHistory();
const stores = createStores({ history });

createRoot(document.getElementById('root')).render(
  <App stores={stores} history={history} />,
);
